import { render, staticRenderFns } from "./DrmForm.vue?vue&type=template&id=48d183f3&"
import script from "./DrmForm.vue?vue&type=script&lang=js&"
export * from "./DrmForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports